import { render, staticRenderFns } from "./ResourcesEndorsementHistory.vue?vue&type=template&id=4688ef49&"
import script from "./ResourcesEndorsementHistory.vue?vue&type=script&lang=js&"
export * from "./ResourcesEndorsementHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports